"use client";

/**
 * Hook to access translations from TranslationContext
 * 
 * This is a wrapper that re-exports useTranslations from TranslationContext
 * to maintain backward compatibility with existing code.
 * 
 * @example
 * ```tsx
 * import useTranslations from '@/app/hooks/useTranslation';
 * 
 * function MyComponent() {
 *   const { translations, language, handleLanguageChange } = useTranslations();
 *   // Use translations...
 * }
 * ```
 */

// Re-export types and hook from TranslationContext
export { useTranslations } from '../contexts/TranslationContext';
export type { TranslationType } from '../contexts/TranslationContext';

// Default export for backward compatibility
import { useTranslations as useTranslationsFromContext } from '../contexts/TranslationContext';
export default useTranslationsFromContext;
